import { Partial } from '@40seas/entities/common';
import { CreateConnectedAccountFundsDto } from './create.connected-account.funds.entity';

export class UpdateConnectedAccountFundsDto extends Partial(CreateConnectedAccountFundsDto) {}
